import { PUBLISHED_STATUS } from '../model/FestivalData';
import { liveVersion } from './publishing';

/** A festival as the master-key festival list gives it: its name in each version, in the order of `versions` */
export interface FestivalExcerpt {
  festival_id: string;
  names: string[];
  /** Missing from older APIs */
  versions?: { version: number; status: PUBLISHED_STATUS; name: string }[];
}

/** A festival's name as the apps show it: its live version's, else its latest version's */
export const festivalName = (festival: FestivalExcerpt): string => {
  const versions = festival.versions ?? [];
  if (versions.length > 0 && versions.length === festival.names.length) {
    const live = liveVersion(versions);
    const latest = versions.reduce((latestIndex, { version }, index) =>
      version > versions[latestIndex].version ? index : latestIndex, 0);
    const shown = live !== null ? versions.findIndex(({ version }) => version === live) : latest;
    if (festival.names[shown]) return festival.names[shown];
  }
  // Without versions to go by, each distinct name once
  const names = Array.from(new Set(festival.names.filter(Boolean)));
  return names.length > 0 ? names.join(', ') : festival.festival_id;
};
